export default __webpack_public_path__ + "static/media/pwaDirection2.409f57ab.png";